import { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { useTranslation } from 'react-i18next';

import axios from "axios";

const Texto = ({ config, datostransferencia }) => {

    const [coordinates, setCoordinates] = useState([]);
    const [loading, setLoading] = useState(true);

    const { t } = useTranslation();

    // Función para obtener coordenadas
    const fetchCoordinates = async () => {
        if (config.latitud && config.longitud) {
            setCoordinates([parseFloat(config.latitud), parseFloat(config.longitud)]);
            setLoading(false);
            return;
        }

        const address = `${config.direccion_fiscal}, ${config.codigo_postal_fiscal}, ${config.poblacion_fiscal}`;
        const address2 = config.poblacion_fiscal;

        try {
            let res = await axios.get(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`
            );

            if (res.data.length > 0) {
                setCoordinates([parseFloat(res.data[0].lat), parseFloat(res.data[0].lon)]);
            } else {
                // Fallback a la segunda búsqueda
                res = await axios.get(
                    `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address2)}`
                );
                if (res.data.length > 0) {
                    setCoordinates([parseFloat(res.data[0].lat), parseFloat(res.data[0].lon)]);
                }
            }
        } catch (err) {
            console.error("Error obteniendo coordenadas:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (config) {
            fetchCoordinates();
        }
    }, [config]);

    return (
        < div >
            <app-landing-section>
                <ng-component>
                    <div className="container">
                        <div className="mb-5 row">
                            <div className="col-md-8 col-lg-9">
                                <p className="text-xl" style={{ marginTop: "25px", marginBottom: "20px" }}>
                                    <strong>{t("Gracias por su reserva")}</strong>
                                </p>

                                <p className="centra">{t("Recuerde completar el pago en la siguente cuenta")}:</p>

                                <div className="p-no text-sm-all" dangerouslySetInnerHTML={{ __html: datostransferencia }}>

                                </div>
                            </div>
                            <div className="col-md-4 col-lg-3">
                                <div className="c-card-map">
                                    <div className="c-card-map__img" style={{ height: "225px" }}>
                                        {(!loading && coordinates.length === 2) ? (
                                            <MapContainer
                                                center={coordinates}
                                                zoom={16}
                                                scrollWheelZoom={false}
                                                style={{ height: "100%", width: "100%", zIndex: "1" }}
                                            >
                                                <TileLayer
                                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                />
                                                <Marker position={coordinates} />
                                            </MapContainer>
                                        ) : (
                                            <div
                                                style={{
                                                    height: "100%",
                                                    width: "100%",
                                                    backgroundColor: "#f8f9fa",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "8px"
                                                }}
                                            >
                                                <div className="text-center text-muted">
                                                    <div className="mb-2 spinner-border spinner-border-sm" role="status"></div>
                                                    <small>{t("Cargando mapa...")}</small>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="c-card-map__body">
                                        <p className="text-xl c-card-map__body-title text-primary">
                                            <strong>{t("CONTACTA CON")} {config.nombre_comercial}</strong>
                                        </p>
                                        <div className="c-card-map__body-info text-gray">
                                            <p>{config.direccion_fiscal}</p>
                                            <p>{config.codigo_postal_fiscal + " " + config.poblacion_fiscal}</p>
                                            <p>{config.telefono_fiscal}</p>
                                            <p>{config.correo_fiscal}</p>
                                            <p>{config.nif_fiscal}</p>
                                        </div>
                                        <a target="_blank" className="btn btn-secondary" href={`https://www.google.com/maps/search/vale+Suites/@${config.latitud},${config.longitud},13z/data=!3m1!4b1?entry=ttu`}> {t("VER EN GOOGLE MAPS")} </a>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </ng-component>
            </app-landing-section>
        </div >
    );
}
export default Texto;
